import ImmutableModel from '@aytm/lib/immutable/ImmutableModel'

import BlockModel from '@aytm/app/insights/dashboard/models/BlockModel'

import { BLOCK_TYPES } from '@aytm/app/insights/dashboard/lib/config'

class BlockConceptLabModel extends ImmutableModel({}, BlockModel) {
  static blockType = BLOCK_TYPES.CONCEPT_LAB
  static title = 'Concept Lab'
  static empty() {
    return BlockConceptLabModel.of().set('showChart', false)
  }
}
ImmutableModel.decorator({ name: 'BlockConceptLabModel', extends: BlockModel })(BlockConceptLabModel)
export default BlockConceptLabModel
